import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[appContentHost]',
    standalone: false
})
export class ContentHostDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
